import { constants, mediaQueryStyles } from "@newsela/angelou";

import fontStyleBuilder from "@/challenges/utils/fontStyleBuilder";

const { ui, brand } = constants.colors;

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, sm },
} = constants.breakpoints;

const neutral700 = ui.neutral[700];
const neutral600 = ui.neutral[600];
const grey = ui.neutral[500];
const white500 = ui.white[500];
const newselaBlue = brand.blue[25];

export const ACTIVITIES_CONTENT = "ACTIVITIES_CONTENT";

export const challengeDetailCardBadgesContentCss = (content) => ({
  display: "flex",
  flexDirection: content === ACTIVITIES_CONTENT ? "row" : "column",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: content === ACTIVITIES_CONTENT ? "16px 0" : "16px 0 6px 0",
  borderBottom: "1px solid rgb(29,29,29,.16)",
  h5: {
    margin: "0",
    color: neutral600,
    ...fontStyleBuilder({
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "178%",
    }),
  },
});

export const challengeDetailCardBadgesTitleCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "4px",
  width: "80%",
};

export const challengeDetailCardCss = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  width: "100%",
  borderRadius: "16px",
  padding: "16px",
  gap: "16px",
  background: "white",
  transition: "box-shadow 0.3s ease-in-out",
  "&:hover": {
    cursor: "pointer",
    "-webkit-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
    "-moz-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
    "box-shadow": "rgba(0, 0, 0, 0.15) 0px 8px 12px 2px",
  },
};

export const challengeDetailCardContentCss = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  width: "100%",
  textAlign: "start",
};

export const challengeDetailCardTitle = {
  width: "100%",
  margin: "8px 0 8px 0",
  color: neutral700,
  maxWidth: "160px",
  ...fontStyleBuilder({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "120%",
  }),
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  [mq.downTo(xs)]: {
    maxWidth: "340px",
  },
  [mq.downTo(sm)]: {
    maxWidth: "240px",
  },
};

export const challengeDetailHeaderCss = {
  position: "relative",
  backgroundColor: neutral600,
  borderTopRightRadius: "16px",
  borderTopLeftRadius: "16px",
};

export const buttonWrapper = {
  display: "block",
  width: "100%",
  justifyContent: "center",
};

export const cardHeaderBackgroundCss = {
  width: "72px",
  height: "72px",
  borderRadius: "8px",
  [mq.downTo(sm)]: {
    height: "104px",
    width: "104px",
  },
};

export const descriptionChallengeTextCss = {
  width: "100%",
  color: grey,
  margin: 0,
  textOverflow: "ellipsis",
  ...fontStyleBuilder({
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "150%",
  }),
};

export const exploreTopicButtonCss = {
  display: "flex",
  width: "100%",
  justifyContent: "center",
  borderRadius: "8px",
};

export const finalScoresCss = {
  color: neutral600,
  ...fontStyleBuilder({
    fontSize: "16px",
    fontWeight: "700",
    lineHeight: "100%",
  }),
};

export const metaCss = {
  display: "flex",
  p: {
    margin: "0px",
    padding: "0px 8px",
    borderRight: "solid",
    borderColor: "rgba(51, 51, 51, 0.3)",
    color: grey,
  },
  "& > p:first-of-type": {
    paddingLeft: "0px",
  },
  "& > p:last-of-type": {
    border: "none",
  },
};

export const possibleTokensNumberCss = {
  color: neutral600,
  ...fontStyleBuilder({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "120%",
  }),

  [mq.upTo(sm)]: {
    ...fontStyleBuilder({
      fontSize: "15px",
      fontWeight: "700",
      lineHeight: "120%",
    }),
  },
};

export const possibleTokensTextCss = {
  ...possibleTokensNumberCss,
  marginTop: "2px",
  ...fontStyleBuilder({
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "133%",
  }),

  [mq.upTo(sm)]: {
    ...fontStyleBuilder({
      fontSize: "10px",
      fontWeight: "400",
      lineHeight: "133%",
    }),
  },
};

export const possibleTokensContainer = {
  position: "absolute",
  display: "flex",
  alignItems: "center",
  padding: "4px 8px",
  backgroundColor: white500,
  border: `2px solid ${newselaBlue}`,
  borderTopRightRadius: "4px",
  borderTopLeftRadius: "4px",
  left: "16px",
  bottom: "0px",
};

export const possibleTokensTeacherHome = {
  display: "flex",
  alignItems: "center",
};

export const topicRowCss = {
  width: "100%",
};

export const metaText = {
  margin: "0px",
  padding: "0px 8px",
  borderRight: "solid",
  borderColor: "rgba(51, 51, 51, 0.3)",
  color: grey,
};

export const divider = {
  height: "1px;",
  flexShrink: 0,
  alignSelf: "stretch",
  opacity: "0.16",
  background: neutral700,
};

export const DetailsTextCss = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "250px",
};
